import { Component, ContentChild, Inject, OnDestroy, OnInit } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { CimbNavigationService, VerticalNavigationComponent, VerticalNavigationAppearance, NavigationItem } from '@red/components/navigation';
import { ActivatedRoute, Router } from '@angular/router';
import { RedMediaWatcherService } from '@red/components/media-watcher';
import { NavigationGroup } from '../navigation/navigation.types';
import { NavigationBaseService, NAVIGATION_SERVICE } from '../navigation/navigation.service';
import { GroupActionHeaderDirective } from '../group-action-header.directive';

@Component({
  selector: 'red-classic-layout',
  templateUrl: './classic-layout.component.html',
  styleUrls: ['./classic-layout.component.scss'],
})
export class ClassicLayoutComponent implements OnInit, OnDestroy {
  isScreenSmall!: boolean;
  naviagtionAppearance: VerticalNavigationAppearance = 'default';
  naviagtionMode: 'over' | 'side' = 'side';
  navigation!: NavigationGroup;
  navigationSelected: NavigationItem[] = [];
  /** Content for the tab label given by `<ng-template redGroupActionHeader>`. */
  @ContentChild(GroupActionHeaderDirective)
  get templateLabel(): GroupActionHeaderDirective | undefined {
    return this._templateLabel;
  }
  set templateLabel(value: GroupActionHeaderDirective | undefined) {
    this._templateLabel = value;
  }

  private _templateLabel?: GroupActionHeaderDirective;
  private _unsubscribeAll: Subject<void> = new Subject<void>();

  /**
   * Constructor
   */
  constructor(
    private _activatedRoute: ActivatedRoute,
    private _router: Router,
    @Inject(NAVIGATION_SERVICE) private _navigationService: NavigationBaseService,
    private _cimbNavigationService: CimbNavigationService,
    private _mediaWatcherService: RedMediaWatcherService
  ) {}
  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  ngOnInit(): void {
    // Subscribe to navigation data
    this._navigationService.navigation$.pipe(takeUntil(this._unsubscribeAll)).subscribe((navigation: NavigationGroup) => {
      this.navigation = navigation;
    });

    // Subscribe to media changes
    this._mediaWatcherService.onMediaChange$.pipe(takeUntil(this._unsubscribeAll)).subscribe(({ matchingAliases, matchingQueries }) => {
      // Check if the screen is small
      const isMobileScreen = matchingAliases.length === 0;
      if (isMobileScreen) {
        this.naviagtionMode = 'over';
        this.naviagtionAppearance = 'default';
      } else {
        this.naviagtionMode = 'side';
        this.isScreenSmall = matchingAliases.length === 0 || !matchingAliases.includes('lg');
        this.naviagtionAppearance = this.isScreenSmall ? 'compact' : 'default';
      }

      this._cimbNavigationService.getComponent<VerticalNavigationComponent>('mainNavigation')?.closeAside();
    });
  }

  /**
   * On destroy
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }
  /**
   * Toggle navigation
   *
   * @param name
   */
  toggleNavigation(name: string): void {
    // Get the navigation
    const navigation = this._cimbNavigationService.getComponent<VerticalNavigationComponent>(name);

    if (navigation) {
      // Toggle the opened status
      navigation.toggle();
    }
  }
}
